import React, { useEffect, useState } from "react";
import './Carousel.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import 'swiper/swiper-bundle.css'
import MenuCard from '../MenuCard/MenuCard';
import * as api from "../../api/index.js";
import styles from "./Carousel.css";
SwiperCore.use([Navigation])

export default function CarouselMenu({ id, trendingDishes }) {
  const [viewMenus, setviewMenus] = useState([]);

  const get = async (id) => {
    try {

      const data = await api.getMenu(id);
      // get(`searchMenu/getMenusByRestaurant/${id}`)
      setviewMenus(data.data);
    
    } catch (error) {
      //setAlert
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (id) {
      get(id)
    }
  }, [id])
  return (
    <React.Fragment>
      <Swiper
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 15
          },
          1366: {
            slidesPerView: 4,
            spaceBetween: 15
          },
          1440: {
            slidesPerView: 4,
            spaceBetween: 15
          },
          1920: {
            slidesPerView: 4,
            spaceBetween: 15
          }
        }}
        direction="horizontal"
        // loop="true"
        navigation
      >

        {viewMenus.map((trending, idx) => (

          <SwiperSlide key={idx} className={styles.SwiperSlide} style={{ width: '230px', }}>
            <MenuCard trending={trending} ids={id} gets={get} />
          </SwiperSlide>


        ))}
        {/* {JSON.stringify(id)} */}

      </Swiper>
    </React.Fragment>
  )
}

